import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-correspondence-grid-cell',
  templateUrl: './correspondence-grid-cell.component.html',
  styleUrls: ['./correspondence-grid-cell.component.scss'],
})
export class CorrespondenceGridCellComponent implements OnInit {
  data: any;
  constructor() {}

  ngOnInit() {}
}
